import { CALL_API } from "../middleware/api";
import {
  GET_SKETCH_ORDERS_FAILURE,
  GET_SKETCH_ORDERS_REQUEST,
  GET_SKETCH_ORDERS_SUCCESS,
} from "./actionTypes";
import SketchAdminSketchOrderClient from "../lib/apiClients/roofSnapApiClient/sketchAdminSketchOrderClient";
import QueryStringBuilder from "../lib/queryStringBuilder";
import UserProfileClient from "../lib/apiClients/roofSnapApiClient/userProfileClient";
import SketchTechSketchOrderClient from "../lib/apiClients/roofSnapApiClient/sketchTechSketchOrderClient";

const getSketchOrdersRequest = (request, params) => {
  return {
    [CALL_API]: {
      types: [
        GET_SKETCH_ORDERS_REQUEST,
        GET_SKETCH_ORDERS_SUCCESS,
        GET_SKETCH_ORDERS_FAILURE,
      ],
      request,
      params,
    },
  };
};

export const getSketchOrders = (
  page = 1,
  statusIds,
  sketchTechUserIds,
  organizationId,
  orderBy,
  sortBy,
  filterByVendor,
  requesterUserId,
  filterStorm = false,
  rush = null,
  metalRoof = null,
) => {
  return (dispatch, getState) => {
    const { isAdmin, isSketchOsAdmin } = getState().currentUserRoles;

    // Depending on the role, determine which endpoint to use
    let request;

    // If the user is an admin or a sketch os admin, use the sketch orders endpoint
    // Otherwise, use the restricted orders endpoint
    if (isAdmin || isSketchOsAdmin) {
      const sketchAdminSketchOrderClient = new SketchAdminSketchOrderClient(
        "v2"
      );
      request = sketchAdminSketchOrderClient.getSketchOrders;
    } else {
      const sketchTechSketchOrderClient = new SketchTechSketchOrderClient("v2");
      request = sketchTechSketchOrderClient.getSketchOrders;
    }

    const queryStringBuilder = new QueryStringBuilder();
    queryStringBuilder.setQueryParameter("page", page);
    if (statusIds) {
      statusIds.forEach((id) => {
        queryStringBuilder.setQueryParameter("statusIds", id);
      });
    }
    if (sketchTechUserIds) {
      sketchTechUserIds.forEach((userId) => {
        queryStringBuilder.setQueryParameter("sketchTechUserIds", userId);
      });
    }
    if (organizationId) {
      queryStringBuilder.setQueryParameter("organizationId", organizationId);
    }
    if (sortBy) {
      queryStringBuilder.setQueryParameter("sort", sortBy);
    }
    if (orderBy) {
      queryStringBuilder.setQueryParameter("order", orderBy);
    }

    if (filterByVendor) {
      if (filterStorm)
        queryStringBuilder.setQueryParameter(
          "namedSketchOrderFilter",
          "StormVendor"
        );
      else
        queryStringBuilder.setQueryParameter(
          "namedSketchOrderFilter",
          "Vendor"
        );
    } else if (filterStorm) {
      queryStringBuilder.setQueryParameter("namedSketchOrderFilter", "Storm");
    }
    if (requesterUserId) {
      queryStringBuilder.setQueryParameter("requesterId", requesterUserId);
    }

    if (rush) {
      queryStringBuilder.setQueryParameter("rush", rush);
    }

    if (metalRoof) {
      queryStringBuilder.setQueryParameter("metalRoof", metalRoof);
    }

    const queryParams = queryStringBuilder.buildQueryString();
    const params = {
      queryParams,
    };

    return dispatch(getSketchOrdersRequest(request, params));
  };
};

export const getRequestersSketchOrders = (requesterUserId, page = 1) => {
  const userProfileClient = new UserProfileClient("v1");
  const request = userProfileClient.getRequestedSketchOrders;

  const queryStringBuilder = new QueryStringBuilder();
  queryStringBuilder.setQueryParameter("page", page);

  const queryParams = queryStringBuilder.buildQueryString();

  return {
    [CALL_API]: {
      types: [
        GET_SKETCH_ORDERS_REQUEST,
        GET_SKETCH_ORDERS_SUCCESS,
        GET_SKETCH_ORDERS_FAILURE,
      ],
      request,
      params: {
        id: requesterUserId,
        queryParams,
      },
    },
  };
};

export const getOwnersSketchOrders = (ownerUserId, page = 1) => {
  const userProfileClient = new UserProfileClient("v1");
  const request = userProfileClient.getOwnedSketchOrders;

  const queryStringBuilder = new QueryStringBuilder();
  queryStringBuilder.setQueryParameter("page", page);

  const queryParams = queryStringBuilder.buildQueryString();

  return {
    [CALL_API]: {
      types: [
        GET_SKETCH_ORDERS_REQUEST,
        GET_SKETCH_ORDERS_SUCCESS,
        GET_SKETCH_ORDERS_FAILURE,
      ],
      request,
      params: {
        id: ownerUserId,
        queryParams,
      },
    },
  };
};
